import { __extends } from "tslib";
import { PutBucketNotificationConfigurationRequest } from "../models/index";
import { deserializeAws_restXmlPutBucketNotificationConfigurationCommand, serializeAws_restXmlPutBucketNotificationConfigurationCommand, } from "../protocols/Aws_restXml";
import { getBucketEndpointPlugin } from "@aws-sdk/middleware-bucket-endpoint";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var PutBucketNotificationConfigurationCommand = /** @class */ (function (_super) {
    __extends(PutBucketNotificationConfigurationCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function PutBucketNotificationConfigurationCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    PutBucketNotificationConfigurationCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use(getBucketEndpointPlugin(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var handlerExecutionContext = {
            logger: logger,
            inputFilterSensitiveLog: PutBucketNotificationConfigurationRequest.filterSensitiveLog,
            outputFilterSensitiveLog: function (output) { return output; },
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    PutBucketNotificationConfigurationCommand.prototype.serialize = function (input, context) {
        return serializeAws_restXmlPutBucketNotificationConfigurationCommand(input, context);
    };
    PutBucketNotificationConfigurationCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restXmlPutBucketNotificationConfigurationCommand(output, context);
    };
    return PutBucketNotificationConfigurationCommand;
}($Command));
export { PutBucketNotificationConfigurationCommand };
//# sourceMappingURL=PutBucketNotificationConfigurationCommand.js.map